import { createFileRoute } from '@tanstack/react-router'
import { KbAdminListView } from '@/features/kb/KbAdminListView'

export const Route = createFileRoute('/admin/kb/')({ component: KbAdminListView })
